// extracted by mini-css-extract-plugin
export default {"wrapper":"BBeZT","index":"jZ0uX","content":"_1Gw7G","link":"_0oB4U","primary":"q8d2C","secondary":"nph47","statistic":"M+pqJ"};